// Fyller den upplyfta variantpris-containern (se
// includes/woocommerce/action-functions/single-product/lw_single_product_variation_price.php)
// med WC:s egen price_html vid variantbyte. WC:s original ligger kvar i
// formuläret men döljs med CSS, så WC:s egen JS kan fortsätta skriva om den
// utan att vi behöver flytta noder fram och tillbaka.
//
// Pristrappor: pricing-tiers.js skriver över .price inuti containern med
// trapp-priset i en setTimeout(0) — den binder sin found_variation-handler före
// den här filen och kör dessutom deferrat, så trapp-priset vinner.
(function () {
    if (!window.jQuery) return

    window.jQuery(function ($) {
        const target = document.querySelector('[data-lw-variation-price]')
        if (!target) return

        const form = $('form.variations_form')
        if (!form.length) return

        form.on('found_variation', function (event, variation) {
            const price = (variation && variation.price_html) || ''
            // Styckpriset ligger som syskon EFTER .price, inte inuti den —
            // pricing-tiers.js skriver om .price vid kvantitetsändring.
            const unit = (price && variation && variation.lw_unit_price_html) || ''
            target.innerHTML = price + unit
        })

        form.on('reset_data hide_variation', function () {
            target.innerHTML = ''
        })
    })
})()
